<template>
  <div class="page-content">
     <div class="container-fluid">
        <!-- start page title -->
        <div class="row">
           <div class="col-12">
              <div class="page-title-box d-flex align-items-center justify-content-between">
                 <h4 class="mb-0 font-size-18">Create New Ticket</h4>
                 <div class="page-title-right">
                    <ol class="breadcrumb m-0">
                       <li class="breadcrumb-item"><a href="javascript: void(0);">Tickets</a></li>
                       <li class="breadcrumb-item active">Create New Ticket</li>
                    </ol>
                 </div>
              </div>
           </div>
        </div>
        <!-- end page title -->
        <div class="row">
           <div class="col-lg-12">
              <div class="card">
                 <div class="card-body">
                    <h4 class="card-title mb-4">New Ticket</h4>
                    <form class="outer-repeater">
                       <div data-repeater-list="outer-group" class="outer">
                          <div data-repeater-item class="outer">
                             <div class="form-group">
                                <label for="department">Select Department:</label>
                                <div>
                                   <select class="form-control" v-model="department">
                                     <option v-bind:key="department.id" v-for="department in departments" :value="department.id"> {{ department.name }} </option>
                                   </select>
                                </div>
                             </div>
                             <div class="form-group">
                                <label for="serviceid">Related Service:</label>
                                <select class="form-control" v-model="service">
                                  <option selected>None</option>
                                  <option v-bind:key="serv.id" v-for="serv in services" :value="serv.id">{{ serv.name + '(' + serv.status + ')'}}</option>
                                </select>

                                <div class="valid-feedback">
                                   Looks good!
                                </div>
                             </div>
                             <div class="form-group">
                                <label for="subject">Subject:</label>
                                <input v-model="subject" type="text" class="form-control" id="subject" placeholder="Enter subject..." required>
                                <div class="valid-feedback">
                                   Looks good!
                                </div>
                             </div>
                             <div class="form-group">
                                <label for="department">Priority:</label>
                                <div>
                                   <select class="form-control" v-model="priority">
                                     <option v-bind:key="prior" v-for="prior in priorities">{{ prior }}</option>
                                   </select>
                                </div>
                             </div>
                             <div class="form-group">
                                <label for="formmessage">Message :</label>
                                <textarea v-model="message" id="formmessage" class="form-control" rows="4"></textarea>
                             </div>
                             <button v-on:click="createTicket" type="submit" class="btn btn-primary">Create</button>
                          </div>
                       </div>
                    </form>
                 </div>
              </div>
           </div>
        </div>
        <!-- end row -->
        <!-- end row -->
        <!-- end row -->
     </div>
  </div>
</template>

<script>
import store from '../../../store'
export default{
  name: 'CreateTicket',
  data () {
    return {
      department: '',
      departments: [],
      service: 'None',
      services: [],
      subject: '',
      priority: 'Low',
      priorities: ['Low', 'Medium', 'High'],
      message: ''
    }
  },
  mounted () {
    this.getInfo()
  },
  methods: {
    getInfo () {
      fetch(store.state.url + '/support/ticket/info', {
        method: 'POST',
        headers: {
          'Authorization': 'Bearer ' + store.state.token
        }
      }).then(response => {
        return response.json()
      }).then(data => {
        if (data.departments) {
          this.departments = data.departments
          this.department = this.departments[0]
        }
        if (data.products) this.services = data.products
      }).catch(err => {
        console.error(err)
      })
    },
    createTicket (e) {
      e.preventDefault()
      let data = new URLSearchParams()
      if (this.department !== null) data.set('department', this.department)
      if (this.service !== '' && this.service !== 'None') data.set('service', this.service)
      if (this.subject === '') return
      data.set('subject', this.subject || 'No Subject')
      if (this.message === '') return
      data.set('message', this.message)
      data.set('priority', this.priority)

      fetch(store.state.url + '/support/ticket/create', {
        method: 'POST',
        headers: {
          'Authorization': 'Bearer ' + store.state.token
        },
        body: data
      }).then(response => {
        return response.json()
      }).then(data => {
        if (data.hasOwnProperty('tid')) {
          this.$router.push({ name: 'view-ticket', params: { id: data.tid } })
        }
      }).catch(err => {
        console.error(err)
      })
    }
  }
}</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/management/support/CreateTicket.vue